import React from "react";

import RequestModal from "../../components/modal/RequestModal";
import Header from "../../components/header/Header";
import Text from "./components/Text";
import Footer from "./components/Footer";

import styles from './Agreement.module.scss';
import CookieNotification from "../main/components/CookieNotification";

function Agreement() {

    const [open, setOpen] = React.useState(false);

    const handleOpen = () => setOpen(true);

    const handleClose = () => setOpen(false);

      return (
          <>
              <div className={styles.app}>
                  <Header handleOpen={handleOpen} isAgreement/>
                  <Text/>
                  <Footer/>
                  <CookieNotification />
              </div>
              <RequestModal open={open} handleClose={handleClose}/>
          </>
      );
}

export default Agreement
